import "./Portfolio.css"

const portfolioItems = [
  {
    icon: "/images/p1.svg", 
    title: "Paper Bags Development",
  },
  {
    icon: "/images/p2.svg",
    title: "Security Tapes & Stickers",
  },
  {
    icon: "/images/p3.svg", 
    title: "Security Packs",
  },
  {
    icon: "/images/p4.svg", 
    title: "Corrugated Boxes",
  },
  {
    icon: "/images/p5.svg",
    title: "Mixed Material Products",
  },
  {
    icon: "/images/p6.svg",
    title: "Product Dyeline Development",
  },
  {
    icon: "/images/p7.svg", 
    title: "Plastic Gift Cards",
  },
  {
    icon: "/images/p8.svg",
    title: "Know More Products",
    isCallToAction: true,
  },
]

function Portfolio() {
  return (
    <section className="portfolio" id="portfolio">
      <div className="portfolio-container">
        <h2 className="section-title">Our Portfolio</h2>
        <div className="portfolio-grid">
          {portfolioItems.map((item, index) => (
            <div
              key={index}
              className={`portfolio-card ${item.isCallToAction ? "cta" : ""}`}
            >
              <div className="portfolio-icon">
                <img src={item.icon} alt={item.title} /> {/* Display image */}
              </div>
              <h3 className="portfolio-title">{item.title}</h3>
            </div>
          ))}
        </div>
        <button className="download-button">
          <span>Download our portfolio as PDF</span>
        </button>
      </div>
    </section>
  )
}

export default Portfolio
